import custom from './custom'

custom.init()


// WEBPACK FOOTER //
// ./src/js/index.js